import React, { FC, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Button, Select, Collapse, Image } from "antd";
import { ReactSVG } from "react-svg";
import { UploadOutlined, CloudDownloadOutlined } from "@ant-design/icons";
import _ from "lodash";
import { Form } from "antd";
import { useLocation } from "react-router-dom";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getProjectsRequestPublishTopic,
  getProjectsSubscriptionTopic,
  getRespondersSubscriptionTopic,
  getAssetsSubscriptionTopic,
  getCreateEventPageSubscriptionTopic,
  getCreateEventPagePublishTopic,
  getPageRequestPublishTopic,
  getPageSubscriptionTopic,
  getAdminRolesTopic,
  getSearchMessagePublishTopic,
  getSearchMessageSubscriptionTopic,
  getCreateCustomPublishTopic,
  getCreateCustomSubscriptionTopic,
  getSearchInCustomPublishTopic,
  getSearchInCustomSubscriptionTopic,
  getUpdateCustomPublishTopic,
  getUpdateCustomSubscriptionTopic,
} from "hooks/MQTTConstants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import {
  SET_CURRENT_PROJECT,
  SET_SUBMITTED,
  ADD_OTHER_LOCATION,
} from "reducers/reducer";
import { pushNotification } from "utils/notifications";
import moment from "moment";
import UploadCSVModal from "./UploadCSVModal";
import useSocketActions from "../../../../hooks/socketActions";
import MultiInput from "../../../../common/MultiInput";
import RenderFields from "../../../../common/RenderFields";
import { formatForRedis, formatObject } from "utils/appUtil";
import csvDownload from "json-to-csv-export";
import ScheduleInput from "../../../../common/ScheduleInput";
import { attributeKeyGenerator } from "utils/appUtil";
import NotifyTypeInput from "../../../../common/NotifyTypeInput";
import ConfirmationModal from "../../../../common/Confirmation";
import { generateUUID } from "utils/appUtil";
import Geocode from "react-geocode";
import { GET_AGGREGATE } from "../../../../reducers/reducer";
import {
  SocketTopics,
  UserTopics,
  CADSectionTopics,
} from "../../../../constants/enums";
import { getCADCustomerSectionPath } from "../../../../hooks/socketConstants";

Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const { Panel } = Collapse;

const DispatchPanel: FC<{ socket: ISocket; params: any }> = ({
  socket,
  params,
}) => {
  const [nine11Form] = Form.useForm();
  const [error, setError] = useState<string>("");
  const { screens, setScreens } = params;
  const { search } = useLocation();
  const history = useHistory();
  const { messages } = useSelector((state: RootState) => state.auth);
  const projects = useSelector(
    (state: RootState) => state.auth.projects,
    (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  );
  const dispatch = useDispatch();
  const { getUserRequestPayload, handleMessages } = useSocketActions();
  const [adminRoles, setAdminRoles] = useState();

  const { sectionList } = useSelector((state: RootState) => state.auth);
  const [searching, setSearching] = useState<boolean>(false);

  const [cadSections, setCadSections] = useState([]);
  const [cadExtendedSections, setCadExtendedSections] = useState({
    what: [],
    account: [],
    where: [],
    who: [],
    when: [],
    why: [],
  });
  const [uploadModalVisible, setUploadModalVisible] = useState<boolean>(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>();
  const [customer, setCustomer] = useState<any>();


  const searchCustomer = (customerId) => {
    return new Promise((resolve, reject)=>{
      const customerRequest: any = {
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:custom:id`,
            // searchIndex: "beamdev:custom:id",
            searchQuery: `@partitions:{'org\\:${formatForRedis(
              projects?.userServiceId
            )}'}`,
            searchOptions: "VERBATIM TIMEOUT 10000",
          },
          load: {
            info: "$.info",
            id: "$.info.id",
            objectId: "$.objectId",
          },
        },
        filter: {
          expression: `exists(@id) && @id==='${customerId}'`,
        },
      };
      dispatch(
        GET_AGGREGATE({
          requestData: customerRequest,
          callback: (response) => {
            const customer = response?.[0];
            console.log("customer response", customer);
            resolve(customer);
          },
        })
      );

    })
  }
      

  const onSubmitHandler = async (values: Nine11Values) => {
    setUploadModalVisible(false);
    const query = new URLSearchParams(search);
    const connectionId = query.get("connectionId");
    const customerId = query.get("customerId");
    console.log("values", values);
    if (values["undefined"]) {
      values = { ...values["undefined"], ...values };
      delete values["undefined"];
    }
    const extendedAttributes = {};
    Object.keys(values).map((key) => {
      _.merge(
        extendedAttributes,
        formatObject(key, key, values[key], cadSections, cadExtendedSections)
      );
    });
    const customerRequestData = {
      id: "",
      type: "customer",
      customer: {},
    };
    if (!selectedCustomer?.value || selectedCustomer?.value === "") {
      setError("**Required customer id");
      return;
    }

    setError(undefined);
    setSearching(true);

    const exist: any = await searchCustomer(selectedCustomer?.value);

    console.log('exis', exist);

    if((customerId && exist && customerId !== exist?.objectId?.toString()) || (!customerId && exist)){
      setError("**customer id must unique");
      setSearching(false);
      return;
    }

    console.log('exist', exist);
    delete extendedAttributes?.[
      selectedCustomer?.itemName?.[0] || selectedCustomer?.itemName?.[1]
    ];

    customerRequestData.id = selectedCustomer?.value;
    customerRequestData.customer = {
      ...extendedAttributes,
    };
    
    if (customerId) {
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getUpdateCustomPublishTopic(connectionId),
        wrapRequestPayload({
          objectId: customerId,
          changes: [
            {
              op: "replace",
              path: "/info",
              value: customerRequestData,
            },
          ],
        })
      );
    } else {
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getCreateCustomPublishTopic(connectionId),
        wrapRequestPayload({
          changes: [
            {
              op: "add",
              path: "/partitions",
              value: [`org:${projects?.userServiceId}`],
            },
            {
              op: "add",
              path: "/info",
              value: customerRequestData,
            },
          ],
        })
      );
    }
  };

  useEffect(() => {
    if (projects?.adminUserId) {
      // getAdminRoles(projects?.adminUserId, projects?.userServiceId);
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.SearchInUser,
        getUserRequestPayload(
          projects?.adminUserId,
          "$",
          getCADCustomerSectionPath()
        ),
        CADSectionTopics.GetSectionList,
        projects?.userServiceId
      );
      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        CADSectionTopics.GetSectionList,
        () => {}
      );
    }
  }, [projects]);

  useEffect(() => {
    if (sectionList) {
      console.log("section list", sectionList);
      let tempCadExtendedSection = { ...cadExtendedSections };
      sectionList?.map((section) => {
        tempCadExtendedSection["account"] = section?.Rows;
      });
      console.log("te", tempCadExtendedSection);
      setCadExtendedSections(tempCadExtendedSection);
    }
  }, [sectionList]);

  useEffect(() => {
    if (cadExtendedSections) {
      const query = new URLSearchParams(search);
      const connectionId = query.get("connectionId");
      const customerId = query.get("customerId");
      if (customerId) {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getSearchInCustomPublishTopic(connectionId),
          wrapRequestPayload({
            objectId: customerId,
            paths: ["$"],
            returnPaths: ["$..info"],
          })
        );
      }
    }
  }, [cadExtendedSections]);

  useEffect(() => {
    if (customer) {
      const tempCustomer = { ...customer?.customer };
      cadExtendedSections?.account.forEach((row: any) => {
        row.Cols.forEach((col: any) => {
          if (col?.type === "location" || col?.type === "incident-location") {
            console.log("col loca", col);

            const incidentLocation = tempCustomer?.[col.name]
              ? {
                  type: "location",
                  label: tempCustomer?.[col.name]?.attributes?.address,
                  value: {
                    description: tempCustomer?.[col.name]?.attributes?.address,
                    place_id: "",
                    coordinates: tempCustomer?.[col.name]?.coordinates,
                  },
                }
              : undefined;

            tempCustomer[col.name] = incidentLocation;
          }
          if (col?.type === "customer-search") {
            tempCustomer[col.name] = customer?.id;
            setSelectedCustomer({itemName: [col.name], value: customer?.id})
          }
        });
      });

      nine11Form.setFieldsValue({
        undefined: tempCustomer,
      });
    }
  }, customer);

  useEffect(() => {
    if (socket.client) {
      const query = new URLSearchParams(search);
      const userId = query.get("userId");
      const connectionId = query.get("connectionId");
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic(connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getRespondersSubscriptionTopic(connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAssetsSubscriptionTopic(connectionId)
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCreateCustomSubscriptionTopic(connectionId),
        (response) => {
          console.log("customer submitted successfully", response);
          setSearching(false);
          pushNotification(
            "Customer saved successfully",
            "success",
            "TOP_CENTER",
            1000
          );
          localStorage.removeItem("form");
          localStorage.removeItem("active");
          setTimeout(() => {
            nine11Form.resetFields();
          }, 500);
          setScreens({
            ...screens,
            map: false,
          });
          const query = new URLSearchParams(search);
          query.delete("customerId");
          history.replace({
            search: query.toString(),
          });
          dispatch({ type: SET_SUBMITTED, payload: false });
        }
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getUpdateCustomSubscriptionTopic(connectionId),
        (response) => {
          console.log("customer updated successfully", response);
          setSearching(false);
          pushNotification(
            "Customer updated successfully",
            "success",
            "TOP_CENTER",
            1000
          );
        }
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getSearchInCustomSubscriptionTopic(connectionId),
        (response) => {
          console.log("response here", response, cadExtendedSections);
          const customer = response?.response?.data?.[0]?.[0];
          setCustomer(customer);
        }
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(connectionId),
        wrapRequestPayload({
          userId,
        })
      );
    }
  }, [search, socket.client]);

  const onProjectChange = (projectId) => {
    dispatch({ type: SET_CURRENT_PROJECT, payload: projectId });
    const values = nine11Form.getFieldsValue();
    Object.keys(values["undefined"] || {}).map((key) => {
      if (values["undefined"]?.[key]?.type === "task-picker") {
        nine11Form.setFieldsValue({
          undefined: {
            ...values["undefined"],
            [key]: undefined,
          },
        });
      }
    });
  };

  const addOtherLocation = (location) => {
    dispatch({ type: ADD_OTHER_LOCATION, payload: location });
    nine11Form.setFieldsValue({
      incidentType: undefined,
    });
    dispatch({
      type: SET_CURRENT_PROJECT,
      payload: undefined,
    });
  };

  return (
    <div className="main-column ride-dispatch-panel mobile-responsive mr-4">
      {uploadModalVisible && (
        <UploadCSVModal
          onClose={() => {
            setUploadModalVisible(false);
          }}
          adminRoles={adminRoles}
          onSubmitHandler={onSubmitHandler}
        />
      )}
      <div className="main-content">
        <Form
          className="auth-form"
          name="register-form"
          // initialValues={JSON.parse(localStorage.getItem("form") || "{}")}
          initialValues={{}}
          id="register-form"
          layout="vertical"
          form={nine11Form}
          onFinish={onSubmitHandler}
          requiredMark={false}
          onValuesChange={(value, allValues) => {
            localStorage.setItem("form", JSON.stringify(allValues));
          }}
        >
          <div className="main-header">
            <div className="d-flex">
              {/* <Image src="/images/incident-icon.png" preview={false} /> */}
              <h3 className="ml-3">Customer</h3>
            </div>
            <div className="d-flex">
              {/* <UploadOutlined
                onClick={() => {
                  setUploadModalVisible(true);
                }}
                style={{
                  color: "#869cbd",
                  fontSize: 20,
                  cursor: "pointer",
                  marginRight: 0,
                }}
              />

              <CloudDownloadOutlined
                onClick={() => {
                  generateCSVFile();
                }}
                style={{
                  color: "#869cbd",
                  fontSize: 20,
                  cursor: "pointer",
                  marginLeft: "1rem",
                }}
              /> */}

              <ReactSVG
                src="/images/map.svg"
                className="close-icon mr-3"
                onClick={() => {
                  setScreens({
                    ...screens,
                    map: true,
                    form: window.innerWidth >= 700,
                  });
                }}
              />

              {/* <ReactSVG
                src="/images/close-icon.svg"
                className="close-icon"
                onClick={() => {
                  setTimeout(() => {
                    localStorage.removeItem("form");
                    localStorage.removeItem("form");
                    dispatch({ type: SET_SUBMITTED, payload: false });
                    nine11Form.resetFields();
                    setScreens({
                      ...screens,
                      map: false,
                    });
                    const query = new URLSearchParams(search);
                    query.delete("pageId");
                    history.replace({
                      search: query.toString(),
                    });
                  });
                }}
              /> */}
            </div>
          </div>
          {/* <Row className="mt-3">
            <Col span={24}>
              <Form.Item name="feature">
                <Select className="w-full" placeholder="Features"></Select>
              </Form.Item>
            </Col>
          </Row> */}
          <div className="main-cards">
            {/* <Collapse
              defaultActiveKey={JSON.parse(
                localStorage.getItem("active") || '["where", "what", "who"]'
              )}
              bordered={false}
              className="simple-collapse"
              onChange={(active) => {
                localStorage.setItem("active", JSON.stringify(active));
              }}
            > */}
            {cadExtendedSections?.["account"]?.length > 0 && (
              // <Panel
              //   header={
              //     <div className="d-flex">
              //       <ReactSVG src="/images/account-icon.svg" />
              //       <h5 className="ml-3">Account</h5>
              //     </div>
              //   }
              //   key="account"
              // >
              <div className="">
                {cadExtendedSections?.["account"]?.map((row, j) => (
                  <Row className={"mt-3"} key={j}>
                    {row?.Cols.map((col, k) => (
                      <Col
                        span={col.ColSize}
                        className={k !== row?.Cols.length - 1 && "pr-2"}
                        xs={24}
                        sm={col.ColSize}
                        key={k}
                      >
                        <RenderFields
                          data={col}
                          projects={projects}
                          addOtherLocation={addOtherLocation}
                          onProjectChange={onProjectChange}
                          onCustomerSearch={(customer) => {
                            console.log("customer", customer);
                            setSelectedCustomer(customer);
                          }}
                          adminRoles={adminRoles}
                        />
                      </Col>
                    ))}
                  </Row>
                ))}
              </div>
              // </Panel>
            )}

            {/* </Collapse> */}
          </div>

          {error && (
            <Form.Item>
              <p className="error">{error}</p>
            </Form.Item>
          )}
          <Row className="action-grp mt-4">
            <Col
              span={12}
              xs={24}
              sm={12}
              className="px-2"
              onClick={() => {
                // onSave();

                setTimeout(() => {
                  localStorage.removeItem("form");
                  localStorage.removeItem("form");
                  dispatch({ type: SET_SUBMITTED, payload: false });
                  nine11Form.resetFields();
                  setScreens({
                    ...screens,
                    map: false,
                  });
                  const query = new URLSearchParams(search);
                  query.delete("customerId");
                  history.replace({
                    search: query.toString(),
                  });
                });
              }}
            >
              <Button
                className="beam-btn yellow-btn cover w-full"
                // loading={saving}
              >
                Clear
              </Button>
            </Col>
            <Col span={12} className="pr-2" xs={24} sm={12}>
              <Form.Item>
                <Button
                  className="beam-btn green-btn cover w-full"
                  htmlType="submit"
                  loading={searching}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default DispatchPanel;
